import { Button } from '@medusajs/ui';

interface OrderCancelButtonProps {
  onClick: () => void;
}

export const OrderCancelButton = ({ onClick }: OrderCancelButtonProps) => {
  return (
    <Button
      variant="secondary"
      onClick={onClick}
      className="rounded-sm border border-solid border-rose-500 px-4 py-2 text-rose-500 hover:bg-rose-50"
      data-testid="order-cancel-button"
    >
      取消訂單
    </Button>
  );
};

export default OrderCancelButton;
